<script lang="ts">
  import { createEventDispatcher } from "svelte"
  import TestCaseTab from "./TestCaseTab.svelte"
  export let evaluations:Array<boolean | null>;
  export let testCaseDatas:Array<{ input:"code"|"interact" }>;
  export let selectedIndex:number = 0;
  export let enabled:boolean = true;
  let dispatch = createEventDispatcher<{selected:number}>();
  
  function handleSelected(index:number) {
    if (!enabled) { return; }
    selectedIndex = index;
    dispatch("selected", index);
  }
</script>

<div>
  {#each evaluations as evaluation, index}
    <TestCaseTab index={index} on:selected={()=>{handleSelected(index)}} evaluation={evaluation} inputType={testCaseDatas[index].input} isSelected={index == selectedIndex}/>
  {/each}
</div>